module.exports = __webpack_public_path__ + "img/next-b&w.762e5fe9.svg";